<template>
  <div style="height: fit-content">
    <!-- 客服 浮动 -->
    <div class="TextFlag">
      <div class="movePointer" @mousedown="draggbleMove" @mouseup="changeBlur">
        <i class="el-icon-rank"></i>
      </div>
      <div class="Flagitem kefu" style="background: #ffffff">
        <a
          target="_blank"
          href="http://wpa.qq.com/msgrd?v=3&uin=2211904562&site=qq&menu=yes"
        >
          <div class="showNav">
            <div class="TB_center">
              <div><img src="./../static/images/kf.png" alt="" /></div>
              <div class="tipText">{{ $t("i18n_online_chat") }}</div>
            </div>
          </div>
        </a>
        <!-- <div class="Showcount">123123</div> -->
      </div>
      <el-popover
        placement="left"
        :title="$t('i18n_cititrans')"
        width="450"
        trigger="hover"
      >
        <div>
          <div class="showCouText">
            <span style="display: inline-block; width: 100px">
              <i class="el-icon-position"></i> {{ $t("i18n_Address") }}：</span
            >{{ $t("i18n_cititrans_address") }}
          </div>
          <div class="showCouText">
            <!-- <p class="showCouText el-icon-phone">
              {{ $t("i18n_hotline_number") }}:
            </p>
            <span style="margin-left: 15px">181-0280-6672</span> -->
            <span style="display: inline-block; width: 100px">
              <i class="el-icon-phone"></i>
              {{ $t("i18n_hotline_number") }}：</span
            >181-0280-6672
          </div>
          <div class="showCouText">
            <!-- <p class="showCouText el-icon-phone">
              {{ $t("i18n_customer_service") }}:
            </p>
            <span style="margin-left: 15px">＋86-755-82143176</span> -->
            <span style="display: inline-block; width: 100px">
              <i class="el-icon-phone"></i>
              {{ $t("i18n_customer_service") }}：</span
            >＋86-755-82143176
          </div>
          <!-- <p class="showCouText el-icon-printer">
            {{ $t("i18n_fax") }}：＋86 755-82143174
          </p> -->
          <div class="showCouText">
            <span style="display: inline-block; width: 100px">
              <i class="el-icon-printer"></i>
              {{ $t("i18n_fax") }}：</span
            >＋86 755-82143174
          </div>
          <!-- <p class="showCouText el-icon-message">
            {{ $t("i18n_Email") }}：info@cititrans.com
          </p> -->
          <div class="showCouText">
            <span style="display: inline-block; width: 100px">
              <i class="el-icon-message"></i>
              {{ $t("i18n_Email") }}：</span
            >info@cititrans.com
          </div>
          <!-- <p class="showCouText" style="font-size: 14px">
            <i class="el-icon-chat-dot-round"></i>
            {{ $t("i18n_WeChat_ID") }}：181-0280-6672
          </p> -->
          <div class="showCouText">
            <span style="display: inline-block; width: 100px">
              <i class="el-icon-chat-dot-round"></i>
              {{ $t("i18n_WeChat_ID") }}：</span
            >181-0280-6672
          </div>
          <div
            style="
              display: flex;
              flex-direction: row;
              gap: 5px;
              justify-content: flex-start;
              width: 100%;
            "
          >
            <div style="width: 100px; font-size: 14px">
              <i class="el-icon-service"></i>
              {{ $t("i18n_Online_WeChat_Customer_service") }}:
            </div>
            <div>
              <img
                style="display: inline-block; width: 130px; height: 130px"
                src="https://0.rc.xiniu.com/g3/M00/07/62/CgAH6F2_5qSAbJcHAABJJ6mvWhI105.png"
                alt=""
              />
              <div
                style="
                  width: 100%;
                  text-align: center;
                  font-size: 11px;
                  color: #999;
                "
              >
                {{ $t("i18n_scan_qr_code_for_service") }}
              </div>
            </div>
          </div>
        </div>
        <div class="Flagitem" slot="reference">
          <div class="showNav">
            <div class="TB_center">
              <div><img src="./../static/images/ip.png" alt="" /></div>
              <div>{{ $t("i18n_contact_us") }}</div>
            </div>
          </div>
          <!-- <div class="Showcount">占位符</div> -->
        </div>
      </el-popover>
      <el-popover placement="left" width="100" trigger="hover">
        <div>
          <img
            style="width: 150px; height: 150px"
            src="./../static/images/xcximg.jpg"
            alt=""
          />
        </div>
        <div class="Flagitem" slot="reference">
          <div class="showNav">
            <div class="TB_center">
              <div><img src="./../static/images/xcx.png" alt="" /></div>
              <div class="tipText">{{ $t("i18n_mini_program") }}</div>
            </div>
          </div>
          <!-- <div class="Showcount">占位符</div> -->
        </div>
      </el-popover>
      <el-popover placement="left" width="400" trigger="hover">
        <div>
          <ul>
            <li class="showCouText" style="line-height: 24px;">
              <div class="warhouse_tit">
                【{{ $t('i18n_warehouse_dongguan') }}】
                <!-- （空/海运） -->
                <el-tag size="small"  effect="dark">{{$t('i18n_warehouse_air_sea')}}</el-tag>
              </div>
              <div>
                  <i class="el-icon-position"></i>{{$t('i18n_Address')}}：{{$t('i18n_warehouse_dongguan_address')}}
              </div>
              <div>
                <i class="el-icon-phone"></i>{{$t('i18n_warehouse_dongguan_contact')}}
              </div>
            </li>
            <li class="showCouText" style="line-height: 24px;">
              <div class="warhouse_tit">
                【{{$t('i18n_warehouse_foshan')}}】
                <!-- （海运） -->
                <el-tag size="small"  effect="dark">{{$t('i18n_warehouse_sea')}}</el-tag>
              </div>
              <div>
                  <i class="el-icon-position"></i>{{$t('i18n_Address')}}：{{$t('i18n_warehouse_foshan_address')}}
              </div>
              <div>
                <i class="el-icon-phone"></i>{{$t('i18n_warehouse_foshan_contact')}}
              </div>
            </li>
            <li class="showCouText" style="line-height: 24px;">
              <div class="warhouse_tit">
                【{{$t('i18n_warehouse_yiwu')}}】
                <!-- （海运） -->
                <el-tag size="small"  effect="dark">{{$t('i18n_warehouse_sea')}}</el-tag>
              </div>
              <div>
                  <i class="el-icon-position"></i>{{$t('i18n_Address')}}：{{$t('i18n_warehouse_yiwu_address')}}
              </div>
              <div>
                <i class="el-icon-phone"></i>{{$t('i18n_warehouse_yiwu_contact')}}
              </div>
            </li>
          </ul>
        </div>
        <div class="Flagitem" slot="reference">
          <div class="showNav">
            <div class="TB_center">
              <div><img style="width: 30px" src="./../static/images/warehouse_ico.png" alt="" /></div>
              <div class="tipText">{{ $t("i18n_warehosue_information") }}</div>
            </div>
          </div>
          <!-- <div class="Showcount">占位符</div> -->
        </div>
      </el-popover>
      <div
        class="Flagitem"
        @click="toTop"
        style="display: flex; align-items: center; justify-content: center"
      >
        <div class="showNav">
          <div class="TB_center">
            <div><img src="./../static/images/top.png" alt="" /></div>
            <!-- <div>{{ $t("i18n_back_to_the_top") }}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 点击拖拽缓存实例
      draggbleRef: '',
      // 相对位置x
      offSetX: '',
      // 相对位置y
      offSetY: ''
    };
  },
  watch: {},
  computed: {},
  methods: {
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    /**
     * 移动函数
     * @param e 父级参数
     * @param event 移动参数
     * */
    moveItem(event) {
      // 计算相对位置
      this.draggbleRef.style.left = event.clientX - this.offSetX + 'px';
      this.draggbleRef.style.top = event.clientY - this.offSetY + 'px';
    },
    /**
     * 鼠标点击后移动时
     * */
    draggbleMove(e) {
      this.draggbleRef = document.querySelector('.TextFlag')
      this.offSetX = e.clientX - this.draggbleRef.offsetLeft
      this.offSetY = e.clientY - this.draggbleRef.offsetTop
      document.addEventListener('mousemove', this.moveItem)
    },
    /**
     * 失去焦点时触发
     * */
    changeBlur() {
      document.removeEventListener('mousemove', this.moveItem)
    }
  },

  created() { },
  mounted() { },
};
</script>

<style scoped>
.TextFlag {
  position: fixed;
  width: 60px;
  height: fit-content;
  z-index: 999;
  right: 0px;
  bottom: 250px;
  bottom: 10%;
  background-color: transparent;
}
/* 侧边导航 */
.Flagitem {
  cursor: pointer;
  margin-top: 10px;
  width: 60px;
  height: fit-content;
  background: #ffffff;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  transition: width 0.5s;
  -webkit-transition: width 0.5s;
  border-radius: 10px;
  transition: transform 300ms;
  box-shadow: 0px 0px 10px 0px rgba(6, 2, 3, 0.13);
}
.showNav {
  width: 66px;
  height: 70px;
  float: left;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.Showcount {
  width: 200px;
  height: 60px;
  float: left;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.showCouText {
  padding: 10px 0;
  width: 100%;
  float: left;
  font-size: 14px;
}
.kefu:hover {
  transform: translate(-10px, 0px);
  transition: transform 300ms;
  box-shadow: 0px 0px 39px 5px rgba(155, 155, 155, 0.32);
}
.tipText {
  text-align: center;
}
.movePointer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 32px;
  cursor: move;
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(6, 2, 3, 0.13);
  background-color: #fff;
}

.movePointer .el-icon-thumb {
  font-size: 20px;
}
.warhouse_tit {
  font-size: 16px;
  color: #333;
}
.warhouse_tit .el-tag {
    vertical-align: 2px;
  }
</style>


// WEBPACK FOOTER //
// common/serviceText.vue